export const formatPostalCode = (postalCode?: string | null) => {
  if (!postalCode) {
    return ''
  }

  return `${postalCode.slice(0, 3)}-${postalCode.slice(3)}`
}
